(function () {
  function initB2B(root) {
    if (!root || root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var revealItems = root.querySelectorAll(".hsw-b2b__reveal");

    if (!reduceMotion && "IntersectionObserver" in window) {
      root.setAttribute("data-reveal", "");

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add("is-visible");
      });
    }

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener("click", function (event) {
        var target = root.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      });
    });
  }

  document.querySelectorAll(".hsw-b2b").forEach(initB2B);

  document.addEventListener("shopify:section:load", function (event) {
    initB2B(event.target.querySelector(".hsw-b2b"));
  });
})();
